<template>
  <modelframe :message="message">
    <my-table
        :data="blacklist"
        :count="blacklist.length"
        :limit="5"
        :column-set="columnSet"
    />
  </modelframe>
</template>

<script>
import myTable from "@/components/myTable";

export default {
  name: "roleManage",
  components:{myTable},
  data(){
    return {
      blacklist:[],
      columnSet:[
        {columnName:'NO',width:'180',label:'用户编号',sortable:true},
        {columnName:'ID',width:'180',label:'产品类型',hidden:true},
        {columnName:'username',width:'180',label:'用户名称'},
        {columnName:'type',width:'180',label:'用户类型',sortable:true},
        {columnName:'telephone',width:'180',label:'手机号',sortable:true},
        {columnName:'time',width:'180',label:'时间',sortable:true},
        {columnName:'blacklist',width:'180',label:'是否黑名单',hidden:true,sortable:true},
      ],
      message:{
        code:0,
        msg:'',
      }
    }
  },
  methods:{
    setMessage(code,msg){
      this.message.code =code;
      this.message.msg =msg;
    },
    initData(data){//将后台数据初始化到userList中
      if(data){
        console.log(JSON.parse(data));
      }else{
        this.blacklist = [
          {NO:'AS32432432',ID:'1',username:'张三',type:'经销商',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS32435432',ID:'1',username:'李四',type:'工程师',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS324324312',ID:'1',username:'王五',type:'销售',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS324344532',ID:'1',username:'赵六',type:'代理商',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS32432903',ID:'1',username:'康十',type:'客户',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS32435432',ID:'1',username:'李四',type:'工程师',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS324324312',ID:'1',username:'王五',type:'销售',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS324344532',ID:'1',username:'赵六',type:'代理商',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS32432903',ID:'1',username:'康十',type:'客户',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS32432903',ID:'1',username:'康十',type:'客户',telephone:'13145677896',time:'20220921000000',blacklist:false},
          {NO:'AS32432903',ID:'1',username:'康十',type:'客户',telephone:'13145677896',time:'20220921000000',blacklist:false},
        ];
      }
    }
  },
  created(){
    this.setMessage(1);//设置Loading
    this.axios.post('http://101.133.156.109:81/api/User/blacklist').then((res)=>{
      let data = res.data
      if(data.status){
        // this.initData(data);
        this.setMessage(0);
      }else{
        this.setMessage(-1,data.msg);
      }
    }).catch((error)=>{
      this.setMessage(-1,'请求数据失败,错误信息：'+error);
    });
    this.initData(false);
  }
}
</script>

<style scoped>

</style>
